import {Component, OnInit} from '@angular/core';
import {LocaliService} from './services/locali/locali.service';
import {MenuController} from '@ionic/angular';
import {NavigationService} from './services/navigation/navigation.service';
import {AuthService} from './services/auth/auth.service';
import {combineLatest, Observable, Subscription} from 'rxjs';
import {Cliente} from './model/cliente.model';
import {Locale} from './model/locale';
import {Title} from '@angular/platform-browser';
import {ClientInfoModalComponent} from './profile/client-info-modal/client-info-modal.component';
import {UtilsService} from './services/utils/utils.service';
import {DateService} from './services/date/date.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {

  localeId: string;
  locali: Locale[] = [];
  locale: Locale;
  user$: Observable<Cliente>;
  alreadyOpened = false;

  favIcon: HTMLLinkElement = document.querySelector('#appIcon');
  cliente: Cliente;

  private subscription: Subscription[] = [];

  constructor(
    private _localiService: LocaliService,
    private _menuController: MenuController,
    private _navigationService: NavigationService,
    private _authService: AuthService,
    private _titleService: Title,
    private _utilsService: UtilsService,
    private _dateService: DateService
  ) {

    this.user$ = this._authService.userData$;

    const arr = [
      this._localiService.getLocali(),
    ];

    combineLatest(arr)
      .subscribe((res: any[]) => {
        this.locali = res?.[0];
        this._localiService.locali$.next(this.locali);
        const ch = this.locali.find(l => l.id === 'club-house');
        if (!this._localiService.localeSelected$.value) {
          this._localiService.localeSelected$.next(ch);
        }
      });

    this._localiService.localeSelected$.subscribe(locale => {

      if (locale) {
        document.body.classList.add(locale?.id);
        this.favIcon.href = `assets/icon/${locale?.id}/favicon.ico`;
        this._titleService.setTitle(locale?.name);

        this.locali.forEach(l => {
          if (l.id !== locale?.id) {
            document.body.classList.remove(l.id);
          }
        });
      }

    });

    this._localiService.localeSelected$.subscribe(locale => this.locale = locale);
  }

  ngOnInit() {
    this.subscription.push(
      this._authService.userData$
        .subscribe(async user => {
          this.cliente = user;

          if (this._authService.uid) {
            const diff = +new Date() - this._dateService.fromDateToMoment(user?.birthDate).valueOf();
            const dateInvalid = (diff / 31556926000) < 11;

            if (
              !user?.uid ||
              !user?.name ||
              !user?.surname ||
              !user?.email ||
              !user?.gender ||
              !user?.phoneNumber
            ) {
              this.alreadyOpened = true;
              await this.openSetInfoModal();
            }
          }
        })
    );
  }

  async openSetInfoModal() {
    await this._utilsService.presentModal(ClientInfoModalComponent, {
      cliente: this.cliente
    }, {
      backdropDismiss: false
    });
  }

  get isNaki() {
    return this._localiService.isNaki;
  }

  get isClub() {
    return this._localiService.isClubHouse;
  }

  get isAuth() {
    return this._authService.isAuthenticated;
  }

  get displayMenu() {
    return this.isNaki || this.isClub;
  }

  toggle() {
    this._menuController.toggle('menuid');
  }

  goToHome() {
    this._navigationService.goToHome(this.locale?.id);
    this.toggle();
  }

  goToLocation() {
    this._navigationService.goToLocation(this.locale?.id);
    this.toggle();
  }

  goToPrivate() {
    this._navigationService.goToPrivateEvents(this.locale?.id);
    this.toggle();
  }

  goToPublic() {
    this._navigationService.goToPublicEvents(this.locale?.id);
    this.toggle();
  }

  goToContacts() {
    this._navigationService.goToContacts(this.locale?.id);
    this.toggle();
  }

  goToLogin() {
    this._navigationService.goToBookings(this.locale?.id);
    this.toggle();
  }

  signOut() {
    this._authService.signOut().then(() => this._navigationService.goToHome(this.locale?.id));
    this.toggle();
  }

  goToProfile() {
    this._navigationService.goToProfile();
    this.toggle();
  }
}
